import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "br-wrap" }
const _hoisted_2 = { class: "br-page-head" }
const _hoisted_3 = { class: "br-header" }
const _hoisted_4 = { class: "br-meta" }
const _hoisted_5 = { class: "br-ua" }
const _hoisted_6 = { class: "br-stare-row" }
const _hoisted_7 = { class: "br-box" }
const _hoisted_8 = { class: "br-console" }
const _hoisted_9 = { class: "br-console" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "br-title" }, "Rapoarte probleme"),
        _createElementVNode("div", { class: "br-sub" }, "Sesizări trimise de utilizatori din aplicație")
      ], -1)),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "#ff2c21",
        onClick: _ctx.load,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-refresh", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode("Reîmprospătează ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.items,
      "key-expr": "ID",
      height: "calc(100vh - 190px)",
      "show-borders": true,
      "show-column-lines": false,
      "show-row-lines": true,
      "row-alternation-enabled": true,
      "hover-state-enabled": true,
      onRowClick: _ctx.openDetail
    }, {
      stareTpl: _withCtx(({ data }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["br-chip", 'st-' + (data.value || 'Nou').toLowerCase()])
        }, _toDisplayString(data.value), 3)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Caută..."
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxColumn, {
          "data-field": "CreatedAt",
          caption: "Data",
          "data-type": "datetime",
          format: "dd.MM.yyyy HH:mm",
          "sort-order": "desc"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "UserName",
          caption: "Utilizator"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Companie",
          caption: "Companie"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Ruta",
          caption: "Pagina"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "VersiuneApp",
          caption: "Versiune",
          width: 90
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Stare",
          caption: "Stare",
          width: 110,
          "cell-template": "stareTpl"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AreScreenshot",
          caption: "Captură",
          "data-type": "boolean",
          width: 80
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowClick"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.detailDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detailDialog) = $event)),
      "max-width": "1200px",
      width: "95vw",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        (_ctx.detail)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "br-detail-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_icon, {
                    color: "white",
                    size: "20",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-bug-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", null, "Raport — " + _toDisplayString(_ctx.formatDate(_ctx.detail.CreatedAt)), 1),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    variant: "text",
                    density: "comfortable",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.detailDialog = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "white",
                        size: "20"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_v_card_text, { class: "br-detail-body" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("b", null, "Utilizator:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.detail.UserName), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("b", null, "Companie:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.detail.Companie), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("b", null, "Pagina:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.detail.Ruta), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("b", null, "Versiune:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.detail.VersiuneApp), 1)
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _cache[12] || (_cache[12] = _createElementVNode("b", null, "Browser:", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.detail.Browser), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "br-label" }, "Stare", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.detail.Stare,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.Stare) = $event)),
                          _ctx.changeStare
                        ],
                        items: _ctx.stariPosibile,
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        style: {"max-width":"220px"}
                      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "br-label mt" }, "Descriere", -1)),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.detail.Descriere || '—'), 1),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "br-label mt" }, "Erori consolă", -1)),
                    _createElementVNode("pre", _hoisted_8, _toDisplayString(_ctx.detail.ConsoleLog || '(fără erori captate)'), 1),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "br-label mt" }, "Activitate rețea (API)", -1)),
                    _createElementVNode("pre", _hoisted_9, _toDisplayString(_ctx.detail.NetworkLog || '(fără activitate captată)'), 1),
                    (_ctx.screenshotUrl)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "br-label mt" }, "Captură de ecran", -1)),
                          _createElementVNode("a", {
                            href: _ctx.screenshotUrl,
                            target: "_blank",
                            rel: "noopener"
                          }, [
                            _createElementVNode("img", {
                              class: "br-screenshot",
                              src: _ctx.screenshotUrl,
                              alt: "captură"
                            }, null, 8, _hoisted_11)
                          ], 8, _hoisted_10)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}